import _ from 'lodash'
import ChartDesignerBreakdown from '../../model/chart-designer-breakdown'
import validBreakdownFieldIds from '../valid-breakdown-field-ids'

/**
 * If there is exactly one date dataset field in the dataset used by the chart,
 * returns the IDs for that field. If there are 0 or more than 1 date fields,
 * returns null.
 *
 * @returns {{datasetId: Number, datasetFieldId: Number, datasetVisibleLinkedFieldId: Number}}
 */
function getSingleDateFieldIds (chart) {
	let datasetIds = _.uniq(chart.getFeatures({ type: 'serie' })
		.filter(f => f.domainType() === 'dataset')
		.map(f => f.get('source').aggregation.startingDatasetId)
		.filter(datasetId => !_.isNil(datasetId)))

	// If there are no datasets, or more than 1 dataset, don't try to autopick
	if (datasetIds.length != 1) {
		return null
	}

	let dataset = chart.data.datasetModel(datasetIds[0])
	// Since this is a CALENDAR_PERIOD_RANGES breakdown, validBreakdownFieldIds()
	// will only return date fields/VLFs
	let validIds = validBreakdownFieldIds({ chart, dataset })
	if (validIds.fieldIds.length === 1) {
		let ids = {
			datasetId: dataset.id,
			datasetFieldId: validIds.fieldIds[0]
		}

		if (validIds.visibleLinkedFieldIds.length === 1) {
			ids.datasetVisibleLinkedFieldId = validIds.visibleLinkedFieldIds[0]
		}

		return ids
	} else {
		return null
	}

}

export default function(model) {
	if (model.breakdowns.length === 0) {
		let breakdown = ChartDesignerBreakdown.calendarPeriodBreakdown(model)
		// If there is a dataset used in the chart, and there is
		// exactly 1 date field in the chart's dataset, automatically
		// use that in the breakdown. If there's more than 1, the
		// user will have to pick it themselves (breakdown will
		// be in error state until then)
		let dateFieldIds = getSingleDateFieldIds(model)
		if (dateFieldIds) {
			dateFieldIds.breakdownTempId = breakdown.tempId
			_.extend(breakdown, { datasetFields: [dateFieldIds] }, dateFieldIds)
		}

		model.breakdowns.push(breakdown)
	}
}